// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homologation-container {
  font-family: Open Sans, sans-serif;
  background: linear-gradient(to bottom, #7ac127, #0b5f80);
  color: white;
  padding: 70px;
}

.homologation-title {
  text-align: center;
  margin-bottom: 30px;
}

.homologation-title h1 {
  font-size: 32px;
  font-weight: bold;
  text-align: left;
  padding-left: 60px;
}

.homologation-content {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: 30px;
  position: relative;
}

.homologation-circle {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.homologation-circle img {
  width: 120%;
  height: 130%;
  border-radius: 50%;
  margin-top: -10px;
}

.homologation-steps {
  flex: 3 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: 20px 0;
}
.location-icons {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 200px;
}

.location-icon {
  position: absolute;
  width: 12px;
  height: 12px;
  background-color: white;
  border-radius: 50%;
  border: 2px solid white;
  z-index: 1;
}

.location-icon .icon-stick {
  position: absolute;
  bottom: -20px;
  left: 50%;
  width: 2px;
  height: 18px;
  background-color: white;
  transform: translateX(-50%);
}

.location-step-1 {
  top: 165px;
  left: 14%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
}

.location-step-3 {
  top: 74px;
  left: 55%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
}

.location-step-5 {
  top: 118px;
  left: 88%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
}

.location-step-2 .icon-stick,
.location-step-4 .icon-stick {
  top: -20px;
}

.location-step-2 {
  top: 180px;
  left: 38%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
}

.location-step-4 {
  top: 122px;
  left: 68%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
}
.step {
  max-width: 100%;
  text-align: center;
  position: relative;
  padding: 10px 0;
}

.step h2 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
  color: white;
  text-align: left;
  padding-left: 5%;
}

.step p {
  font-size: 13px;
  line-height: 1.5;
  width: 90%;
  margin: 0 auto;
  text-align: left;
}

.curved-line {
  position: absolute;
  top: 0;
  left: -6.5%;
  width: 100%;
  height: 200px;
  z-index: 0;
  stroke-dasharray: 9, 9;
}

.what-is-homologation {
  top: -50px;
  left: 50px;
  text-align: start;
}

.pre-homologation-process {
  top: 170px;
  left: 60px;
}

.documentation {
  top: -130px;
  left: 20px;
}

.testing-validation {
  top: 110px;
  left: 10px;
}

.certification {
  top: -110px;
  left: 20px;
}

.what-is-homologation .step-title1 img {
  position: absolute;
  left: -40px;
  top: 20px;
  width: 40px;
  height: auto;
}

.pre-homologation-process .step-title2 img {
  position: absolute;
  left: -45px;
  top: 25px;
  width: 40px;
  height: auto;
}

.documentation .step-title3 img {
  position: absolute;
  left: -35px;
  top: 30px;
  width: 25px;
  height: auto;
}

.testing-validation .step-title4 img {
  position: absolute;
  left: -45px;
  top: 20px;
  width: 35px;
  height: auto;
}

.certification .step-title img {
  position: absolute;
  left: -45px;
  top: 20px;
  width: 40px;
  height: auto;
}
.step-image {
  display: none;
  width: 100%;
  height: auto;
  margin-top: 15px;
}

@media screen and (max-width: 768px) {
  .homologation-content {
    flex-direction: column;
    align-items: center;
  }
  .homologation-title {
    text-align: center;
    margin-bottom: 40px;
  }
  .homologation-steps {
    flex-direction: column;
    gap: 20px;
    padding: 0;
  }

  .curved-line {
    display: none;
  }

  .step {
    max-width: 100%;
  }
  .step-image {
    display: block;
    width: 20px;
    height: 70px;
    position: relative;
    right: -80px;
    top: 20px;
  }

  .location-icons,
  .location-icon,
  .location-icon .icon-stick {
    display: none;
  }
  .homologation-title h1 {
    font-size: 32px;
    font-weight: bold;
    text-align: left;
    padding-left: 30px;
  }

  .what-is-homologation {
    top: -10px;
    left: 20px;
  }

  .pre-homologation-process {
    top: -10px;
    left: 20px;
  }

  .documentation {
    top: -10px;
    left: 20px;
  }

  .testing-validation {
    top: -10px;
    left: 20px;
  }

  .certification {
    top: -10px;
    left: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/HomologationFirst/HomologationFirst.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,wDAAwD;EACxD,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,SAAS;EACT,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,SAAS;EACT,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,SAAS;EACT,wCAAwC;AAC1C;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,SAAS;EACT,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,SAAS;EACT,wCAAwC;AAC1C;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,aAAa;EACb,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;EACA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,SAAS;EACX;;EAEA;;;IAGE,aAAa;EACf;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,UAAU;EACZ;AACF","sourcesContent":[".homologation-container {\n  font-family: Open Sans, sans-serif;\n  background: linear-gradient(to bottom, #7ac127, #0b5f80);\n  color: white;\n  padding: 70px;\n}\n\n.homologation-title {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.homologation-title h1 {\n  font-size: 32px;\n  font-weight: bold;\n  text-align: left;\n  padding-left: 60px;\n}\n\n.homologation-content {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 30px;\n  position: relative;\n}\n\n.homologation-circle {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.homologation-circle img {\n  width: 120%;\n  height: 130%;\n  border-radius: 50%;\n  margin-top: -10px;\n}\n\n.homologation-steps {\n  flex: 3;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n  padding: 20px 0;\n}\n.location-icons {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 200px;\n}\n\n.location-icon {\n  position: absolute;\n  width: 12px;\n  height: 12px;\n  background-color: white;\n  border-radius: 50%;\n  border: 2px solid white;\n  z-index: 1;\n}\n\n.location-icon .icon-stick {\n  position: absolute;\n  bottom: -20px;\n  left: 50%;\n  width: 2px;\n  height: 18px;\n  background-color: white;\n  transform: translateX(-50%);\n}\n\n.location-step-1 {\n  top: 165px;\n  left: 14%;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n}\n\n.location-step-3 {\n  top: 74px;\n  left: 55%;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n}\n\n.location-step-5 {\n  top: 118px;\n  left: 88%;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n}\n\n.location-step-2 .icon-stick,\n.location-step-4 .icon-stick {\n  top: -20px;\n}\n\n.location-step-2 {\n  top: 180px;\n  left: 38%;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n}\n\n.location-step-4 {\n  top: 122px;\n  left: 68%;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n}\n.step {\n  max-width: 100%;\n  text-align: center;\n  position: relative;\n  padding: 10px 0;\n}\n\n.step h2 {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 10px;\n  color: white;\n  text-align: left;\n  padding-left: 5%;\n}\n\n.step p {\n  font-size: 13px;\n  line-height: 1.5;\n  width: 90%;\n  margin: 0 auto;\n  text-align: left;\n}\n\n.curved-line {\n  position: absolute;\n  top: 0;\n  left: -6.5%;\n  width: 100%;\n  height: 200px;\n  z-index: 0;\n  stroke-dasharray: 9, 9;\n}\n\n.what-is-homologation {\n  top: -50px;\n  left: 50px;\n  text-align: start;\n}\n\n.pre-homologation-process {\n  top: 170px;\n  left: 60px;\n}\n\n.documentation {\n  top: -130px;\n  left: 20px;\n}\n\n.testing-validation {\n  top: 110px;\n  left: 10px;\n}\n\n.certification {\n  top: -110px;\n  left: 20px;\n}\n\n.what-is-homologation .step-title1 img {\n  position: absolute;\n  left: -40px;\n  top: 20px;\n  width: 40px;\n  height: auto;\n}\n\n.pre-homologation-process .step-title2 img {\n  position: absolute;\n  left: -45px;\n  top: 25px;\n  width: 40px;\n  height: auto;\n}\n\n.documentation .step-title3 img {\n  position: absolute;\n  left: -35px;\n  top: 30px;\n  width: 25px;\n  height: auto;\n}\n\n.testing-validation .step-title4 img {\n  position: absolute;\n  left: -45px;\n  top: 20px;\n  width: 35px;\n  height: auto;\n}\n\n.certification .step-title img {\n  position: absolute;\n  left: -45px;\n  top: 20px;\n  width: 40px;\n  height: auto;\n}\n.step-image {\n  display: none;\n  width: 100%;\n  height: auto;\n  margin-top: 15px;\n}\n\n@media screen and (max-width: 768px) {\n  .homologation-content {\n    flex-direction: column;\n    align-items: center;\n  }\n  .homologation-title {\n    text-align: center;\n    margin-bottom: 40px;\n  }\n  .homologation-steps {\n    flex-direction: column;\n    gap: 20px;\n    padding: 0;\n  }\n\n  .curved-line {\n    display: none;\n  }\n\n  .step {\n    max-width: 100%;\n  }\n  .step-image {\n    display: block;\n    width: 20px;\n    height: 70px;\n    position: relative;\n    right: -80px;\n    top: 20px;\n  }\n\n  .location-icons,\n  .location-icon,\n  .location-icon .icon-stick {\n    display: none;\n  }\n  .homologation-title h1 {\n    font-size: 32px;\n    font-weight: bold;\n    text-align: left;\n    padding-left: 30px;\n  }\n\n  .what-is-homologation {\n    top: -10px;\n    left: 20px;\n  }\n\n  .pre-homologation-process {\n    top: -10px;\n    left: 20px;\n  }\n\n  .documentation {\n    top: -10px;\n    left: 20px;\n  }\n\n  .testing-validation {\n    top: -10px;\n    left: 20px;\n  }\n\n  .certification {\n    top: -10px;\n    left: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
